/*============================================================================
  NewsletterReminder
==============================================================================*/

class NewsletterReminder extends HTMLElement {
  constructor() {
    super()
    this.closeBtn = this.querySelector('[data-close-button]')
    this.popupTrigger = this.querySelector('[data-message]')

    this.id = this.dataset.sectionId
    this.newsletterId = `NewsletterPopup-${this.id}`
    this.cookie = Cookies.get(`newsletter-${this.id}`)
    this.cookieName = `newsletter-${this.id}`
    this.secondsBeforeShow = this.dataset.delaySeconds
    this.expiry = parseInt(this.dataset.delayDays)
    this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, 'newsletter-popup-modal')

    this.init()
  }

  init() {
    document.addEventListener('shopify:block:select', (evt) => {
      if (evt.detail.sectionId === this.id) {
        this.show(0, true)
      }
    })

    document.addEventListener('shopify:block:deselect', (evt) => {
      if (evt.detail.sectionId === this.id) {
        this.hide()
      }
    })

    document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide())
    document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show())

    this.closeBtn.addEventListener('click', () => {
      this.hide()
      Cookies.set(this.cookieName, 'opened', { path: '/', expires: this.expiry })
    })

    this.popupTrigger.addEventListener('click', () => {
      const reminderOpen = new CustomEvent('reminder:openNewsletter', { bubbles: true })
      this.dispatchEvent(reminderOpen)

      this.hide()
    })
  }

  show(time = this.secondsBeforeShow, forceOpen = false) {
    if (!sessionStorage.getItem('newsletterAppeared') === true || forceOpen) {
      setTimeout(() => {
        this.dataset.enabled = 'true'
        if (!forceOpen) sessionStorage.setItem('newsletterAppeared', true)
      }, time * 1000)
    }
  }

  hide() {
    this.dataset.enabled = 'false'
  }
}

customElements.define('newsletter-reminder', NewsletterReminder)

theme.NewsletterPopup = (function () {
  function NewsletterPopup(container) {
    this.container = container
    var sectionId = this.container.getAttribute('data-section-id')

    this.cookieName = 'newsletter-' + sectionId
    this.cookie = Cookies.get(this.cookieName)

    if (!container) {
      return
    }

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return
    }

    // Prevent popup on password page
    if (window.location.pathname === '/password') {
      return
    }

    this.data = {
      secondsBeforeShow: container.dataset.delaySeconds,
      daysBeforeReappear: container.dataset.delayDays,
      hasReminder: container.dataset.hasReminder,
      testMode: container.dataset.testMode,
      isEnabled: container.dataset.enabled,
    }

    this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal')

    // Set cookie if optional button is clicked
    var btn = container.querySelector('.popup-cta a')
    if (btn) {
      btn.addEventListener(
        'click',
        function () {
          this.closePopup(true)
        }.bind(this)
      )
    }

    // Open modal if errors or success message exist
    if (container.querySelector('.errors') || container.querySelector('.note--success')) {
      this.modal.open()
    }

    // Set cookie as opened if success message
    if (container.querySelector('.note--success')) {
      this.closePopup(true)
      return
    }

    document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this))

    if (!this.cookie && this.data.isEnabled === 'true') {
      this.initPopupDelay()
    }

    // Open modal if triggered by newsletter reminder
    document.addEventListener('reminder:openNewsletter', () => {
      this.modal.open()
    })
  }

  NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
    initPopupDelay: function () {
      if (this.data.testMode === 'true') {
        return
      }
      setTimeout(
        function () {
          this.modal.open()
        }.bind(this),
        this.data.secondsBeforeShow * 1000
      )
    },

    closePopup: function (success) {
      // Remove a cookie in case it was set in test mode
      if (this.data.testMode === 'true') {
        Cookies.remove(this.cookieName, { path: '/' })
        return
      }

      var expiry = success ? 200 : this.data.daysBeforeReappear
      var hasReminder = this.data.hasReminder === 'true'
      var newsletterAppeared = sessionStorage.getItem('newsletterAppeared') === 'true'

      if (hasReminder && newsletterAppeared) {
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry })
      } else if (!hasReminder) {
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry })
      }
    },

    onLoad: function () {
      this.modal.open()
    },

    onSelect: function () {
      this.modal.open()
    },

    onDeselect: function () {
      this.modal.close()
    },

    onBlockSelect: function () {
      this.modal.close()
    },

    onBlockDeselect: function () {
      this.modal.open()
    },
  })

  return NewsletterPopup
})()

;(function () {
  'use strict'

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback()
    else document.addEventListener('DOMContentLoaded', callback)
  }

  DOMready(function () {
    theme.sections = new theme.Sections()

    theme.sections.register('slideshow-section', theme.SlideshowSection)
    theme.sections.register('header', theme.HeaderSection)
    theme.sections.register('product', theme.Product)
    theme.sections.register('blog', theme.Blog)
    theme.sections.register('password-header', theme.PasswordHeader)
    theme.sections.register('photoswipe', theme.Photoswipe)
    theme.sections.register('product-recommendations', theme.Recommendations)
    theme.sections.register('background-image', theme.BackgroundImage)
    theme.sections.register('testimonials', theme.Testimonials)
    theme.sections.register('video-section', theme.VideoSection)
    theme.sections.register('map', theme.Maps)
    theme.sections.register('footer-section', theme.FooterSection)
    theme.sections.register('store-availability', theme.StoreAvailability)
    theme.sections.register('recently-viewed', theme.RecentlyViewed)
    theme.sections.register('newsletter-popup', theme.NewsletterPopup)
    theme.sections.register('collection-header', theme.CollectionHeader)
    theme.sections.register('collection-grid', theme.Collection)

    theme.initGlobals()
    theme.initQuickShop()
    theme.rteInit()

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm')
      if (cartPageForm) {
        new theme.CartForm(cartPageForm)
      }
    }

    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init()
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates()
    }

    document.dispatchEvent(new CustomEvent('page:loaded'))
  })
})()
